// extracted by mini-css-extract-plugin
module.exports = {"localVideo":"LocalVideo_localVideo__2q3Wf","enabled":"LocalVideo_enabled__2fcAB","video":"LocalVideo_video__3-Jp0"};